import {useMutation} from '@tanstack/react-query';
import {
  addAudioRedaction,
  deleteAudioRedaction,
  getAudioRedactions,
} from '../../api/endpoints/documentApi';
import {
  IDocumentMediaRedactionRequest,
  IDocumentRedaction,
} from '../../api/types/document.type';

export const useDocumentMediaRedactions = (
  onSuccess?: (data: IDocumentRedaction[]) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, IDocumentMediaRedactionRequest>({
    mutationKey: ['getAudioRedactions'],
    mutationFn: (params: IDocumentMediaRedactionRequest) =>
      getAudioRedactions(params),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useDocumentMediaAddEditRedaction = (
  onSuccess?: (data: any) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, IDocumentRedaction>({
    mutationKey: ['addAudioRedaction'],
    mutationFn: (payload) => addAudioRedaction(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useDocumentMediaDeleteRedaction = (
  onSuccess?: (data: any) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, IDocumentRedaction>({
    mutationKey: ['deleteAudioRedaction'],
    mutationFn: (payload: IDocumentRedaction) => deleteAudioRedaction(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
